module.exports = window["MaterialUI"].Dialog;